import HallThumbnail from '~/assets/img/areas-comuns/hall.jpg'
import Hall from '~/assets/img/areas-comuns/originais/hall.jpg'
import SalaoThumbnail from '~/assets/img/areas-comuns/salao-de-festas.jpg'
import Salao from '~/assets/img/areas-comuns/originais/salao-de-festas.jpg'
import GourmetThumbnail from '~/assets/img/areas-comuns/espaco-gourmet.jpg'
import Gourmet from '~/assets/img/areas-comuns/originais/espaco-gourmet.jpg'
import GourmetClose from '~/assets/img/areas-comuns/espaco-gourmet-detalhe.jpg'
import QuadraThumbnail from '~/assets/img/areas-comuns/quadra.jpg'
import Quadra from '~/assets/img/areas-comuns/originais/quadra.jpg'
import PlaygroundThumbnail from '~/assets/img/areas-comuns/playground.jpg'
import Playground from '~/assets/img/areas-comuns/originais/playground.jpg'
import KidsThumbnail from '~/assets/img/areas-comuns/kids.jpg'
import Kids from '~/assets/img/areas-comuns/originais/kids.jpg'
import OficinaThumbnail from '~/assets/img/areas-comuns/oficina.jpg'
import Oficina from '~/assets/img/areas-comuns/originais/oficina.jpg'
import PetPlaceThumbnail from '~/assets/img/areas-comuns/pet-place.jpg'
import PetPlace from '~/assets/img/areas-comuns/originais/pet-place.jpg'
import BicicletarioThumbnail from '~/assets/img/areas-comuns/bicicletario.jpg'
import Bicicletario from '~/assets/img/areas-comuns/originais/bicicletario.jpg'
import Garagem from '~/assets/img/areas-comuns/garagem.jpg'
import LavacaoThumbnail from '~/assets/img/areas-comuns/lavacao.jpg'
import Lavacao from '~/assets/img/areas-comuns/originais/lavacao.jpg'
import HortaThumbnail from '~/assets/img/areas-comuns/horta.jpg'
import Horta from '~/assets/img/areas-comuns/originais/horta.jpg'
import Piscina from '~/assets/img/areas-comuns/piscina.jpg'
import PiscinaClose from '~/assets/img/areas-comuns/detalhe-piscina.jpg'
import PrainhaThumbnail from '~/assets/img/areas-comuns/piscina-prainha.jpg'
import Prainha from '~/assets/img/areas-comuns/originais/piscina-prainha.jpg'
import PiscinaTermicaThumbnail from '~/assets/img/areas-comuns/piscina-termica.jpg'
import PiscinaTermica from '~/assets/img/areas-comuns/originais/piscina-termica.jpg'
import PiscinaTorres from '~/assets/img/areas-comuns/piscina-torres.jpg'
import FitnessThumbnail from '~/assets/img/areas-comuns/fitness-interno.jpg'
import Fitness from '~/assets/img/areas-comuns/originais/fitness-interno.jpg'
import FitnessExternoThumbnail from '~/assets/img/areas-comuns/fitness-externo.jpg'
import FitnessExterno from '~/assets/img/areas-comuns/originais/fitness-externo.jpg'
import FitnessClose from '~/assets/img/areas-comuns/academia-vista.jpg'
import CooworkingThumbnail from '~/assets/img/areas-comuns/coworking.jpg'
import Cooworking from '~/assets/img/areas-comuns/originais/coworking.jpg'
import SportsBarThumbnail from '~/assets/img/areas-comuns/sports-bar.jpg'
import SportsBar from '~/assets/img/areas-comuns/originais/sports-bar.jpg'
import BoulevardThumbnail from '~/assets/img/areas-comuns/boulevard.jpg'
import Boulevard from '~/assets/img/areas-comuns/originais/boulevard.jpg'
import Boulevard2Thumbnail from '~/assets/img/areas-comuns/boulevard2.jpg'
import Boulevard2 from '~/assets/img/areas-comuns/originais/boulevard2.jpg'
import FunLoungeThumbnail from '~/assets/img/areas-comuns/fun-lounge.jpg'
import FunLounge from '~/assets/img/areas-comuns/originais/fun-lounge.jpg'
import PoolLoungeThumbnail from '~/assets/img/areas-comuns/pool-lounge.jpg'
import PoolLounge from '~/assets/img/areas-comuns/originais/pool-lounge.jpg'
import GrillThumbnail from '~/assets/img/areas-comuns/grill.jpg'
import Grill from '~/assets/img/areas-comuns/originais/grill.jpg'

type CommonAreas = Array<{
  items: Array<{
    thumbnail?: string
    image?: string
  }>
}>

const data: CommonAreas = [
  {
    items: [
      {
        thumbnail: HallThumbnail,
        image: Hall,
      },
      {
        thumbnail: BoulevardThumbnail,
        image: Boulevard,
      },
      {
        thumbnail: Boulevard2Thumbnail,
        image: Boulevard2,
      },
      {
        thumbnail: HortaThumbnail,
        image: Horta,
      },
      {
        thumbnail: GourmetThumbnail,
        image: Gourmet,
      },
      {
        thumbnail: GourmetClose,
        image: GourmetClose,
      },
      {
        thumbnail: LavacaoThumbnail,
        image: Lavacao,
      },
      {
        thumbnail: FitnessExternoThumbnail,
        image: FitnessExterno,
      },
      {
        thumbnail: FitnessClose,
        image: FitnessClose,
      },
      {
        thumbnail: FitnessThumbnail,
        image: Fitness,
      },
      {
        thumbnail: PoolLoungeThumbnail,
        image: PoolLounge,
      },
      {
        thumbnail: Piscina,
        image: Piscina,
      },
      {
        thumbnail: PiscinaClose,
        image: PiscinaClose,
      },
      {
        thumbnail: PiscinaTermicaThumbnail,
        image: PiscinaTermica,
      },
      {
        thumbnail: PrainhaThumbnail,
        image: Prainha,
      },
      {
        thumbnail: PiscinaTorres,
        image: PiscinaTorres,
      },
      {
        thumbnail: SalaoThumbnail,
        image: Salao,
      },
      {
        thumbnail: KidsThumbnail,
        image: Kids,
      },
      {
        thumbnail: GrillThumbnail,
        image: Grill,
      },
      {
        thumbnail: SportsBarThumbnail,
        image: SportsBar,
      },
      {
        thumbnail: FunLoungeThumbnail,
        image: FunLounge,
      },
      {
        thumbnail: CooworkingThumbnail,
        image: Cooworking,
      },
    ],
  },
  {
    items: [
      {
        thumbnail: Garagem,
        image: Garagem,
      },
      {
        thumbnail: QuadraThumbnail,
        image: Quadra,
      },
      {
        thumbnail: OficinaThumbnail,
        image: Oficina,
      },
      {
        thumbnail: BicicletarioThumbnail,
        image: Bicicletario,
      },
      {
        thumbnail: PlaygroundThumbnail,
        image: Playground,
      },
      {
        thumbnail: PetPlaceThumbnail,
        image: PetPlace,
      },
    ],
  },
]

export default data
